import { ExternalLink } from "lucide-react";
import { Reveal } from "@/components/site/Motion";

export const PROCORE_URL = "https://network.procore.com/p/alumicom-inc-vaughan";

export const ProcoreBadge = ({ className = "", compact = false }) => (
  <Reveal className={`card relative overflow-hidden p-6 md:p-8 ${compact ? "md:flex md:items-center md:justify-between md:gap-8" : ""} ${className}`}>
    <div className="absolute inset-y-0 left-0 w-1 bg-[#E85D24]" aria-hidden="true" />
    <div className={compact ? "md:flex md:items-center md:gap-8" : ""}>
      <div className="shrink-0">
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-[#3E5468]">Directory profile</p>
        <img src="/img/procore-logo.png" alt="Procore" width="1200" height="152" loading="lazy" className="mt-3 h-7 w-auto md:h-8" data-testid="procore-logo" />
      </div>
      <p className={`text-base leading-relaxed text-[#151A20] ${compact ? "mt-4 md:mt-0 md:max-w-xl" : "mt-4"}`}>Alumicom Inc. is listed on the Procore Construction Network, where contractors can review the company's profile.</p>
    </div>
    <a href={PROCORE_URL} target="_blank" rel="noopener noreferrer" className={`btn-glass shrink-0 ${compact ? "mt-6 md:mt-0" : "mt-6"}`} data-testid="procore-verify-btn">
      Verify on Procore <ExternalLink aria-hidden="true" size={16} />
    </a>
  </Reveal>
);
